const defaultTheme = {
  highlight: "#FF8E5E",
  primary: "#51a671"
};

export { defaultTheme };
